import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

class Recommend extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        if (content && content.length === 0) return <div />;

        const main = content[0];

        return (
            <div className={styles.box}>
                <h3>
                    <a href={main.url} target="_blank">
                        {main.title}
                    </a>
                </h3>
                <div className="clearfix">
                    <div className={styles.pic}>
                        <a href={main.url} target="_blank">
                            <img src={main.img} alt={main.title} width="132" height="155" />
                        </a>
                    </div>
                    <ul>
                        {content.slice(1).map((item, index) => (
                            <li key={index} className="clearfix">
                                ·<a href={item.url} target="_blank" title={item.title}>
                                    {item.title}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Recommend);
